import { NgClass, DatePipe, NgStyle, NgIf } from '@angular/common';
import {
  Component,
  signal,
  inject,
  Signal,
  WritableSignal,
  effect,
  computed,
  OnDestroy,
  DestroyRef,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import {
  interval,
  Observable,
  startWith,
  Subject,
  switchMap,
  takeUntil,
} from 'rxjs';
import { CategoryFilterComponent } from '../../components/category-filter/category-filter.component';
import { FilteredAuctionTimerComponent } from '../../components/filtered-auction-timer/filtered-auction-timer.component';
import { Auction } from '../../models/auction.model';
import { Category } from '../../models/category.model';
import { AuctionsService } from '../../services/auctions.service';
import { InfoButtonComponent } from '../../components/info-button/info-button.component';
import { HomePageService } from './home-page.service';
import { ICoreStart } from '../../models/core.model';

@Component({
  selector: 'app-home-page',
  imports: [
    ButtonModule,
    CardModule,
    TableModule,
    ToastModule,
  ],
  templateUrl: './home-page.component.html',
  standalone: true,
  styleUrl: './home-page.component.scss',
})
export class HomePageComponent implements OnDestroy {
  open = signal(false);
  private auctionsService: AuctionsService = inject(AuctionsService);
  private route: ActivatedRoute = inject(ActivatedRoute);
  homePageService = inject(HomePageService);

  private readonly destroy$: Subject<void> = new Subject<void>();
  protected auctions: Signal<Auction[]> = toSignal(
    this.auctionsService.getAuctionsList(),
    { initialValue: [] }
  );
  protected filteredAuctions: WritableSignal<Auction[]> = signal([]);

  protected coreList: Signal<ICoreStart> = toSignal(
    this.pollEvery(30000, () => this.auctionsService.getCoreStart()),
    {
      initialValue: { auctionsCount: 0, onReelCount: 0 },
    }
  );
  // protected categories: Signal<Category[]> = toSignal(
  //   this.pollEvery(30000, () => this.auctionsService.getCategoriesWithCount()),
  //   { initialValue: [] }
  // );
  // protected codesCategories: Signal<Category[]> = toSignal(
  //   this.pollEvery(30000, () => this.auctionsService.getCodesWithCount()),
  //   { initialValue: [] }
  // );

  // protected categories: Signal<Category[]> = signal(categoryFilterMockData);
  // protected codesCategories: Signal<Category[]> = signal(
  //   categoryFilterMockDataCodes
  // );

  protected totalSeconds = signal<number>(0);

  // protected focusedView: 'none' | 'auctions' | 'codes' = 'none';

  ngOnInit(): void {
    console.log('coreList', this.coreList());
    const view = this.route.snapshot.queryParamMap.get('view');
    if (view === 'auctions' || view === 'codes') {
      this.homePageService.focusedView$.set(view);
    } else {
      this.homePageService.focusedView$.set('none');
    }
  }

  selectView(view: 'auctions' | 'codes') {
    console.log('view', view);
    // if (this.homePageService.focusedView$() === view) {
    //   this.goBack();
    //   return;
    // }

    if (view === 'auctions') {
      this.router.navigate(['/auction-list/']);
    }
     if (view === 'codes') {
      this.router.navigate(['/codes-reel/']);
    }

    // this.homePageService.focusedView$.set(view);

    // this.router.navigate([], {
    //   relativeTo: this.route,
    //   queryParams: { view },
    //   queryParamsHandling: 'merge',
    // });
  }

  goBack() {
    this.homePageService.focusedView$.set('none');
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { view: null },
      queryParamsHandling: 'merge',
    });
  }

  // filterDataForFocusedView() {
  //   return this.homePageService.focusedView$() === 'auctions'
  //     ? this.categories()
  //     : this.codesCategories();
  // }

  constructor(private router: Router, private messages: MessageService) {
    const nav = this.router.getCurrentNavigation();
    const toast = nav?.extras?.state?.['toast'];
    if (toast) this.messages.add(toast);
    // effect(() => {
    //   const data = this.auctions();
    //   console.log('data', data);
    //   if (data.length === 1) {
    //     const auction = data[0];
    //     const now = new Date();
    //     const startAt = new Date(auction.startAt.replace(' ', 'T'));
    //     const secondsLeft = Math.floor(
    //       (startAt.getTime() - now.getTime()) / 1000
    //     );
    //     this.totalSeconds.set(secondsLeft > 0 ? secondsLeft : 0);
    //   }
    // });
    // interval(1000).subscribe(() => {
    //   const current = this.totalSeconds();
    //   console.log('current', current);
    //   if (current > 0) {
    //     this.totalSeconds.update((s) => s - 1);
    //   } else {
    //     if (this.auctions().length === 1) {
    //       this.router.navigate(['/auction', this.auctions()[0].id]);
    //     }
    //   }
    // });
  }

  timeUnits = computed(() => {
    const total = this.totalSeconds();
    const pad = (n: number) => (n < 10 ? '0' + n : '' + n);

    const days = Math.floor(total / 86400);
    const hours = Math.floor((total % 86400) / 3600);
    const minutes = Math.floor((total % 3600) / 60);
    const seconds = total % 60;

    const rawUnits = [
      {
        label: this.pluralize(days, ['dzień', 'dni', 'dni']),
        value: pad(days),
        raw: days,
      },
      {
        label: this.pluralize(hours, ['godzina', 'godziny', 'godzin']),
        value: pad(hours),
        raw: hours,
      },
      {
        label: this.pluralize(minutes, ['minuta', 'minuty', 'minut']),
        value: pad(minutes),
        raw: minutes,
      },
      {
        label: this.pluralize(seconds, ['sekunda', 'sekundy', 'sekund']),
        value: pad(seconds),
        raw: seconds,
      },
    ];

    const visibleUnits = rawUnits.filter((u) => u.raw > 0);
    return visibleUnits.length > 0 ? visibleUnits : [rawUnits[3]];
  });

  public goToAuction(auction: Auction): void {
    if (auction.state === 'ongoing') {
      this.router.navigate(['/auction', auction.id]);
    } else {
      return;
    }
  }

  // public filterAuctions(categoryId: string): void {
  //   console.log('filterAuctions', categoryId);

  //   const viewFromQuery = this.route.snapshot.queryParamMap.get('view');
  //   const isCodes =
  //     this.homePageService.focusedView$() === 'codes' ||
  //     viewFromQuery === 'codes' ||
  //     window.location.pathname.includes('/codes');
  //   console.log('isCodes', isCodes);
  //   if (isCodes) {
  //     this.auctionsService
  //       .getCodesListByCategory(categoryId)
  //       .pipe(takeUntil(this.destroy$))
  //       .subscribe({
  //         next: (codesList: any) => {
  //           console.log('codes-reel', codesList);
  //           this.router.navigate(['/codes-reel/', categoryId], {
  //             state: { codesList },
  //           });
  //         },
  //         error: (error) => {
  //           console.error('getCodesListByCategory failed', error);
  //         },
  //       });

  //     return;
  //   }

  //   this.auctionsService.getAuctionsListByCategory(categoryId).subscribe({
  //     next: (auctions) => {
  //       console.log('auctions', auctions);
  //       this.router.navigate(['/auction-list/', categoryId], {
  //         state: { auctions },
  //       });
  //     },
  //     error: (error) => {
  //       console.error('getAuctionsListByCategory failed', error);
  //     },
  //   });
  // }

  private pluralize(value: number, forms: [string, string, string]): string {
    if (value === 1) return forms[0];
    if (
      value % 10 >= 2 &&
      value % 10 <= 4 &&
      (value % 100 < 10 || value % 100 >= 20)
    ) {
      return forms[1];
    }
    return forms[2];
  }

  private pollEvery<T>(ms: number, getFn: () => Observable<T>) {
    return interval(ms).pipe(
      startWith(0),
      switchMap(() => getFn()),
      takeUntil(this.destroy$)
    );
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
